export default "__VITE_ASSET__3ea74dc1__"